import { AnalyticsEvent, SendAnalyticsEvent } from 'shared/entities/analytics';
import { OnboardingStep } from 'shared/entities/onboarding';

import {
  isOnboardingStepCompleted,
  setOnboardingFinishSent,
  setOnboardingQuickStartSent,
  wasOnboardingFinishSent,
  wasOnboardingQuickStartSent
} from '../storage/stepStorage';

const QUICK_START_STEP_IDS: readonly OnboardingStep[] = [
  OnboardingStep.channelCreate,
  OnboardingStep.scenarioCreate
];

const FINISH_STEP_IDS: readonly OnboardingStep[] = [
  OnboardingStep.channelCreate,
  OnboardingStep.scenarioCreate,
  OnboardingStep.botCapabilities,
  OnboardingStep.botCreationDemo
];

export const trySendOnboardingQuickStart = (
  sendEvent: SendAnalyticsEvent
): void => {
  if (wasOnboardingQuickStartSent()) {
    return;
  }

  if (!QUICK_START_STEP_IDS.every(isOnboardingStepCompleted)) {
    return;
  }

  sendEvent(AnalyticsEvent.onboardingQuickStart);
  setOnboardingQuickStartSent();
};

export const trySendOnboardingFinish = (
  sendEvent: SendAnalyticsEvent
): void => {
  if (wasOnboardingFinishSent()) {
    return;
  }

  if (!FINISH_STEP_IDS.every(isOnboardingStepCompleted)) {
    return;
  }

  sendEvent(AnalyticsEvent.onboardingFinish);
  setOnboardingFinishSent();
};
